import React, { useState } from "react";
import MeansCalculator from "./MeansCalculator";

function MeansCalc() {
  const [value, setValue] = useState();

  function onCalculate(computedValue) {
    setValue(computedValue);
  }

  return (
    <div>
      <h1>Sample Size and Experiment Run-time Calculator</h1>
      <h2>(for means metrics)</h2>
      <MeansCalculator onCalculate={onCalculate} />
      {value && (
        <div>
          <strong>Result:</strong>
          <pre>
            <code>{value}</code>
          </pre>
        </div>
      )}
    </div>
  );
}

export default MeansCalc;
